<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'StorageLoadComponent',
  created () {
    this.onSincronizar();
  },
  methods: {
    async onSincronizar() {
      try {
        // Sucursales
        const sucursales = await JSON.parse(window.sessionStorage.getItem('suc'))
        await this.$store.commit('Sucursales/setAll', sucursales)
        // Sucursal seleccionada
        const sucursalId = await JSON.parse(window.sessionStorage.getItem('sucid'))
        await this.$store.commit('Sucursales/setSelected', sucursales.find(item => item.id === sucursalId))
        // Productos
        const productos = await JSON.parse(window.sessionStorage.getItem('pro'))
        await this.$store.commit('Productos/setAll', productos)
        // Formas de pago
        const formasPagos = await JSON.parse(window.sessionStorage.getItem('pag'))
        await this.$store.commit('FormasPagos/setAll', formasPagos)
        // Precios
        const precios = await JSON.parse(window.sessionStorage.getItem('pre'))
        await this.$store.commit('PreciosVigentes/setAll', precios)
        // Parametros
        const parametros = await JSON.parse(window.sessionStorage.getItem('par'))
        await this.$store.commit('Parametros/setAll', parametros)
        // Choferes
        // const choferes = await JSON.parse(window.sessionStorage.getItem('cho'))
        // await this.$store.commit('ChoferesAll/setAll', choferes)
      } catch (error) {
        console.error('Error en el proceso de carga Storage:', error);
      }
    },
  }
}
</script>